import React, { useState } from 'react'
import styled from 'styled-components'
import APIIcon from '../asset/APIIcon'
import FileIcon from '../asset/FileIcon'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  width: 232px;
  max-height: 100%;
  background-color: #fff;
  overflow: hidden;
`

const Head = styled.div`
  display: flex;
  padding: 16px;
  background: #373a40;
  gap: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

const TitleWrapper = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Title = styled.div`
  font-family: SUIT;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
`

const ButtonWrapper = styled.div`
  display: flex;
  gap: 6px;
`

const Button = styled.div`
  display: flex;
  height: 25px;
  padding: 4px 6px 4px 6px;
  border: 1px solid #b3b3b3;
  border-radius: 4px;
  background: #ffffff;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

const ButtonText = styled.span`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }
`

export const APIListWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  max-height: 100%;
  min-height: 0;
`

interface SearchItemProps {
  selected?: boolean
}

const SearchItemList = styled.div<SearchItemProps>`
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: 6px;
  gap: 8px;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? '#F0F2F7' : 'transparent')};
`

interface Props {
  title?: string
  dataList?: any[]
  noApi?: boolean
  noFile?: boolean
  setSelected?: Function
  apiFunc?: any
  fileFunc?: () => void
}

const APIList = (props: Props) => {
  const { title, noApi, noFile, dataList, setSelected, apiFunc, fileFunc } =
    props
  const [selectedItem, setSelectedItem] = useState<any>(null)

  const handleItemClick = (item: any) => {
    setSelectedItem(item)
    if (setSelected) setSelected(item)
  }

  return (
    <Wrapper>
      <Head>
        <TitleWrapper>
          <Title>{title || '목록'}</Title>
          <ButtonWrapper>
            {!noFile && (
              <Button onClick={() => fileFunc?.()}>
                <FileIcon />
                <ButtonText>파일</ButtonText>
              </Button>
            )}
            {!noApi && apiFunc && (
              <Button onClick={() => apiFunc()}>
                <APIIcon />
                <ButtonText>API</ButtonText>
              </Button>
            )}
          </ButtonWrapper>
        </TitleWrapper>
      </Head>
      <Body>
        {dataList &&
          dataList?.map((item, index) => (
            <SearchItemList
              key={index}
              selected={selectedItem === item}
              onClick={() => handleItemClick(item)}
            >
              {item}
            </SearchItemList>
          ))}
      </Body>
    </Wrapper>
  )
}

export default APIList
